/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Why a companion can or cannot be put on a tour, as far as is knowable without routing.  Deliberately does NOT cover \"the route cannot be built with them\": answering that means an OR-Tools solve per candidate, ten seconds each, which is not something a dropdown can wait for. The save answers it, explains itself, and lets the manager override. This enum is what the list can say instantly and truthfully.
 */
export const TaxiAttendantChangePossibilityReason = {
    Available: 'Available',
    AlreadyInOtherTour: 'AlreadyInOtherTour'
} as const;
export type TaxiAttendantChangePossibilityReason = typeof TaxiAttendantChangePossibilityReason[keyof typeof TaxiAttendantChangePossibilityReason];

